import React, { Component } from 'react';

import './NavBar.scss'
import { PAGE_NAME } from 'utils/constants';

export default class NavBar extends Component {
	constructor(props) {
		super(props);
		let children = this.checkChildren()
		this.state = {
			navTitles: children && children[0] ? children[0] : undefined,
			navElements: children && children[1] ? children[1] : undefined,
			fixedBar: false,
			activeTab: this.setInitial()
		};
	}
	componentDidMount() {
		this.setElements()
	}
	componentDidUpdate() {
		this.setElements()
	}
	setInitial() {
		let initial = 0
		if (this.props.children && this.props.children.length) {
			for (let i = 0; i < this.props.children.length; i++) {
				if (this.props.children[i] && this.props.children[i].props && this.props.children[i].props.navTitle && this.props.children[i].props.children && this.props.children[i].props.default) {
					initial = i
				}
			}
		}
		return initial
	}
	setElements() {
		let children = this.checkChildren()
		if (children && children.length) {
			this.setState({ navTitles: children[0], navElements: children[1] })
		}
	}
	checkChildren() {
		if (this.props.children) {
			let navTitles = []
			let navElements = []
			for (let i = 0; i < this.props.children.length; i++) {
				if (this.props.children[i] && this.props.children[i].props && this.props.children[i].props.navTitle && this.props.children[i].props.children) {
					navTitles.push({
            'dataQA': this.props.children[i].props.dataQA,
						'firstTitle': this.props.children[i].props.navFirstTitle ? this.props.children[i].props.navFirstTitle : "",
						'title': this.props.children[i].props.navTitle,
						'linkTo': this.props.children[i].props.linkTo ? this.props.children[i].props.linkTo : null,
						'linkToNewTab': this.props.children[i].props.linkToNewTab ? this.props.children[i].props.linkToNewTab : null,
						'default': this.props.children[i].props.default ? true : false
					})
					navElements.push({
						'element': this.props.children[i],
						'i': i,
						'default': this.props.children[i].props.default ? true : false
					})
				}
			}
			if (
				navTitles.length
				&& (
					!this.state ||
					JSON.stringify(navTitles) != JSON.stringify(this.state.navTitles)
				)
			) {
				return [navTitles, navElements]
			}
		}
		return undefined
	}
	handleTabClick(i) {
		if (this.props.pageName != PAGE_NAME.HOME)
			this.props.resetNewFilters()

		if (!this.state.navTitles[i].linkTo) {
			this.props.children[i].props.onClick && this.props.children[i].props.onClick()
			this.setActiveTab(i)
		}

	}
	setActiveTab(i) {
		this.setState({ activeTab: i })
	}
	renderBar() {
		let tabs = []
		if (this.state.navTitles && this.state.navTitles.length) {
			for (let i = 0; i < this.state.navTitles.length; i++) {
				let className = 'NavBar--item'
				if (this.state.activeTab === i) {
					className += ' is--active'
				} else if (this.state.navTitles[i].default) {
					this.setActiveTab(i)
				}
				if (this.props.pageName == PAGE_NAME.HOME) {
					if (i == 0) {
						tabs.push(
							<h1
								key={"navBarTab" + i}
                data-qa={this.state.navTitles[i].dataQA}
								className={className}
								onClick={this.handleTabClick.bind(this, i)}
								href={this.state.navTitles[i].linkTo ? this.state.navTitles[i].linkTo : undefined}
								target={this.state.navTitles[i].linkTo && this.state.navTitles[i].linkToNewTab ? "_blank" : ''}
								rel="noreferrer">
								<small>{this.state.navTitles[i].firstTitle}</small>
								{this.state.navTitles[i].title}
							</h1>

						)
					} else {
						tabs.push(
							<h2
								key={"navBarTab" + i}
								className={className}
								onClick={this.handleTabClick.bind(this, i)}
							>
								<a
                  data-qa={this.state.navTitles[i].dataQA}
									href={this.state.navTitles[i].linkTo ? this.state.navTitles[i].linkTo : undefined}
									target={this.state.navTitles[i].linkTo && this.state.navTitles[i].linkToNewTab ? "_blank" : ''}
									rel="noreferrer">
									<small>{this.state.navTitles[i].firstTitle}</small>
									{this.state.navTitles[i].title}
								</a>
							</h2>
						)
					}
				}
				else {
					tabs.push(
						<a
							key={"navBarTab" + i}
              data-qa={this.state.navTitles[i].dataQA}
							className={className}
							onClick={this.handleTabClick.bind(this, i)}
							href={this.state.navTitles[i].linkTo ? this.state.navTitles[i].linkTo : undefined}
							target={this.state.navTitles[i].linkTo && this.state.navTitles[i].linkToNewTab ? "_blank" : ''}
							rel="noreferrer">
							<small>{this.state.navTitles[i].firstTitle}</small>
							{this.state.navTitles[i].title}
						</a>
					)
				}

			}
			if (tabs.length) {
				return tabs
			}
		}
		return ''
	}
	render() {
		return (
			<div className="NavBar">
			<div className='NavBar--tabs'>{this.renderBar()}</div>
				<div className="NavBar--content">{this.props.children[this.state.activeTab]}</div>
			</div>
		)
	}
}
